import { render, staticRenderFns } from "./componentCollapseTo.vue?vue&type=template&id=43ef9b85&scoped=true"
import script from "./componentCollapseTo.vue?vue&type=script&lang=js"
export * from "./componentCollapseTo.vue?vue&type=script&lang=js"
import style0 from "./componentCollapseTo.vue?vue&type=style&index=0&id=43ef9b85&lang=scss"
import style1 from "./componentCollapseTo.vue?vue&type=style&index=1&id=43ef9b85&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ef9b85",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43ef9b85')) {
      api.createRecord('43ef9b85', component.options)
    } else {
      api.reload('43ef9b85', component.options)
    }
    module.hot.accept("./componentCollapseTo.vue?vue&type=template&id=43ef9b85&scoped=true", function () {
      api.rerender('43ef9b85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/componentCollapseTo.vue"
export default component.exports